/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
import { LogLevel } from '@azure/msal-browser';

interface Config {
	domainName: string,
	signUpSignInFlowName: string,
	clientId: string,
	accessScope: string,
}

let b2cConfig = {
	domainName: import.meta.env.VITE_ADB2C_DOMAIN_NAME,// 'norebasebeta',
	signUpSignInFlowName: import.meta.env.VITE_ADB2C_SIGNUP_SIGNIN_NAME,
	clientId: import.meta.env.VITE_ADB2C_CLIENT_ID,// '126b8618-9f63-49ee-9176-be05aeb8049b',
	accessScope: import.meta.env.VITE_ADB2C_ACCESS_SCOPE,// 'https://norebasebeta.onmicrosoft.com/48e0b026-1c58-477a-bbb4-4e613f0aa817/access_as_user',
	redirectUrl: import.meta.env.VITE_ADB2C_REDIRECT_URI // '/signupsuccess'
} as Config;
//let b2cConfig = {} as Config;

// const ResolveConfig =()=>{
//   switch(true){
//     case domainName.toLowerCase().indexOf('df')>-1:
//       b2cConfig = B2cConfigs.canary;
//       break;
//     case domainName.toLowerCase().indexOf('dev')>-1:
//     case domainName.toLowerCase().indexOf('localhost')>-1:
//       b2cConfig = B2cConfigs.dev;
//       break;
//     default:
//       b2cConfig = B2cConfigs.prod;
//   }
// }

//ResolveConfig();
/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
	names: {
		signUpSignIn: b2cConfig.signUpSignInFlowName,
	},
	authorities: {
		signUpSignIn: {
			authority:
				`https://${b2cConfig.domainName}.b2clogin.com/${b2cConfig.domainName}.onmicrosoft.com/${b2cConfig.signUpSignInFlowName}`,
		}
	},
	authorityDomain: `${b2cConfig.domainName}.b2clogin.com`,
}

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
	auth: {
		clientId: b2cConfig.clientId, // This is the ONLY mandatory field that you need to supply.
		authority:  b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
		knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
		redirectUri: import.meta.env.VITE_ADB2C_REDIRECT_URI, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
		postLogoutRedirectUri: import.meta.env.VITE_ADB2C_REDIRECT_URI, // Indicates the page to navigate after logout.
		navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
	},
	cache: {
		cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
		storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
	},
	system: {
		loggerOptions: {
			loggerCallback: (level: any, message: any, containsPii: any) => {
				if (containsPii) return;

				if (import.meta.env.VITE_HIDE_ADB2C_LOGS) return;

				switch (level) {
					case LogLevel.Error:
						console.error(message)
						return
					case LogLevel.Info:
						console.info(message)
						return
					case LogLevel.Verbose:
						console.debug(message)
						return
					case LogLevel.Warning:
						console.warn(message)
						return
				}
			},
		},
	},
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
	scopes: ['openid',b2cConfig.accessScope],
}
